import 'react-select/dist/react-select.css';

import * as React from 'react';

import { default as ReactSelect } from 'react-select';
import { Tag } from 'common/api/models/Tag';

export interface EditableTagsProps {
  tagIds: string[];
  tags: { [id: string]: Tag };
  type?: Tag.Type;
  canEdit: boolean;
  onSave: (tagIds: string[]) => void;
  label?: string;
}

export interface EditableTagsState {
  value: SelectValue[];
  allTags: Tag[];
  isEditing: boolean;
  error?: string;
}

interface SelectValue {
  label: string;
  value: string;
}

export class EditableTags extends React.Component<EditableTagsProps, EditableTagsState> {
  static defaultProps = {
    blacklistedTagTypes: [],
    label: 'Edit Tags',
  };

  state: EditableTagsState = { isEditing: false, value: [], allTags: [] };

  handleEdit = (e: React.MouseEvent<HTMLButtonElement>) => {
    let tags: Tag[] = [];
    for (let k in this.props.tags) {
      if (this.props.tags.hasOwnProperty(k)) {
        tags.push(this.props.tags[k]);
      }
    }

    tags = tags
      // Filter internal/external
      .filter(
        t => (this.props.type ? t.type === this.props.type : t.type !== Tag.Type.INTERNAL && t.type !== Tag.Type.BADGE)
      );

    this.setState({
      isEditing: true,
      allTags: tags,
      value: this.props.tagIds.map(id => {
        return { label: this.props.tags[id] ? this.props.tags[id].name! : '', value: id };
      }),
    });
  };

  handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    this.setState({ isEditing: false });
  };

  handleSave = (e: React.MouseEvent<HTMLButtonElement>) => {
    this.props.onSave(this.state.value.map(t => t.value));
    this.setState({ isEditing: false });
  };

  handleChangeTags = (value: any) => {
    this.setState({ value: value });
  };

  getTagName = (tagId: string) => {
    return this.props.tags[tagId] ? this.props.tags[tagId].name : '';
  };

  render() {
    if (!this.state.isEditing) {
      return (
        <div>
          <div>
            {this.props.tags.length === 0 && <span>None</span>}
            {this.props.tagIds &&
              this.props.tagIds.length > 0 &&
              this.props.tagIds.map(id => this.getTagName(id)).join(', ')}{' '}
          </div>
          {this.props.canEdit && (
            <div style={{ marginTop: 5 }}>
              <button className="btn btn-sm btn-secondary" onClick={this.handleEdit}>
                {this.props.label}
              </button>
            </div>
          )}
        </div>
      );
    } else {
      const selectOptions = this.state.allTags.map(t => {
        return { label: t.name + ` - ` + t.type, value: t.id };
      });
      return (
        <div>
          <div>
            <ReactSelect
              name="select-tags"
              multi={true}
              value={this.state.value}
              options={selectOptions}
              onChange={this.handleChangeTags}
            />
          </div>
          <div style={{ marginTop: 5 }}>
            <button className="btn btn-sm btn-secondary" onClick={this.handleCancel}>
              Cancel
            </button>{' '}
            <button className="btn btn-sm btn-primary" onClick={this.handleSave}>
              Save
            </button>
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/EditableTags.tsx